import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { ALERTS } from '../initData';
import PlugModal from '../../../widgets/plug/PlugModal/PlugModal';

const OfficeAlertContent = ({ data }) => {
    const [activeAlert, setActiveAlert] = useState(true);

    useEffect(() => {
        setTimeout(() => {
            window.location.hash = '';
        }, 1000);
    }, []);

    if (!activeAlert) return null;

    return <PlugModal data={data} closeHandler={setActiveAlert} />;
};
const OfficeAlert = ({}) => {
    const router = useRouter();

    const hashActiveAlert = router.asPath.split('#')[1];

    if (!hashActiveAlert || !ALERTS[hashActiveAlert]) return null;

    return <OfficeAlertContent data={ALERTS[hashActiveAlert]} />;
};
export default OfficeAlert;
